import type { FaireProductEntity } from "../../entity_types/product";

export const p_vubvgncxs5: FaireProductEntity = {
  token: "p_vubvgncxs5",
  type: "product",
  name: "Organic Cotton Compression Socks",
  brandToken: "b_dtik0xdswq",
  brandName: "Maggie's Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/b0b5abd475dc0ed5687599baf0fc8e7d9d53b12275a41bed494d2d99ac663baa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6a8a8659fa4e1132275eb8461a60738ba89ec7aaf5f66209ffcc248395ded00.jpeg",
    "https://cdn.faire.com/fastly/5bfc5d7f5fccb3e6b3a36b60a130cd753672f28b5713053fd5f4dab2e2ca0f14.jpeg",
    "https://cdn.faire.com/fastly/d2ba9dc27590fef0fb02fa1944553b68a9c038bdd9230ca11279aae87edf4ce7.jpeg",
    "https://cdn.faire.com/fastly/3698b38e11779729f7c0e55ec530a72954f7d2e6d14b8f9d4bb74d4594c3cbcf.jpeg",
  ],
  priceDollars: 9,
  description:
    "Our compression socks are made from soft organic cotton. Graduated compression for gentle, all-day support. Great for the office, long flights, after exercise, during pregnancy, and more.\nThe pressure in compression socks is measured in millimeters of mercury (mm Hg). Our light supportive compression socks have a rating of 12 mm Hg, for gentle support through graduated compression. Graduated compression means the sock’s pressure is strongest near the ankle, and is reduced gradually up the sock.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:45.706Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
